import React from 'react';
import { Card, CardContent } from './ui/card';
import { Award, TrendingUp, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const qualityIcons = [Award, TrendingUp, MapPin];

export const About = () => {
  return (
    <section id="about" className="py-32 bg-white relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-emerald-50/30 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left: Single elegant photo */}
          <div className="relative">
            {/* Main photo - large and elegant */}
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-emerald-600/20 to-emerald-400/10 rounded-[2rem] transform rotate-3" />
              <div className="relative rounded-[2rem] overflow-hidden shadow-2xl">
                <img 
                  src={mockData.about.image1} 
                  alt="Anaïs - Diagnostiqueuse immobilière MONDIAGIMMO"
                  className="w-full h-[700px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/40 via-transparent to-transparent" />
              </div>
            </div>

            {/* Elegant name badge */}
            <div className="absolute -bottom-8 left-8 bg-white rounded-2xl shadow-2xl px-8 py-6 border-2 border-emerald-200">
              <p className="text-3xl font-bold text-stone-900">{mockData.about.name}</p>
              <p className="text-emerald-700 font-medium">Fondatrice MONDIAGIMMO</p>
            </div>
          </div>

          {/* Right: Text content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 text-emerald-700">
                <div className="w-12 h-[2px] bg-emerald-700" />
                <span className="text-sm uppercase tracking-widest font-medium">Votre Experte</span>
              </div>
              
              <h2 className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight">
                {mockData.about.title}
              </h2>
            </div>
            
            <div className="text-lg text-stone-600 leading-relaxed space-y-4">
              <p>{mockData.about.description}</p>
            </div>

            {/* Quality cards - refined */}
            <div className="space-y-4 pt-6">
              {mockData.about.qualities.map((quality, index) => {
                const Icon = qualityIcons[index];
                return (
                  <div 
                    key={index}
                    className="group flex gap-4 p-6 rounded-xl bg-stone-50 hover:bg-emerald-50 border border-stone-200 hover:border-emerald-300 transition-all duration-300"
                  >
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-emerald-700 to-emerald-600 flex items-center justify-center flex-shrink-0 shadow-md">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <div className="space-y-1">
                      <h3 className="text-lg font-bold text-stone-900">
                        {quality.title}
                      </h3>
                      <p className="text-stone-600 text-sm">
                        {quality.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};